import { render, staticRenderFns } from "./login-history.vue?vue&type=template&id=5b0d7a7f&scoped=true"
import script from "./login-history.vue?vue&type=script&lang=js"
export * from "./login-history.vue?vue&type=script&lang=js"
import style0 from "./login-history.vue?vue&type=style&index=0&id=5b0d7a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d7a7f",
  null
  
)

export default component.exports